<template>
  <div class="bg_home">
    <app-home-banner :filteredAnnouncement="filteredAnnouncement"></app-home-banner>

    <app-game-tab-holder></app-game-tab-holder>
    <app-referral-home-banner></app-referral-home-banner>
    <div class=" pb-2 px-4" :class="$vuetify.breakpoint.mdAndUp ? 'pt-4' : 'pt-2'">
      <div :style="$vuetify.breakpoint.mdAndUp ? 'max-width:1240px; margin:auto;' : ''">
        <v-row justify="start" align="center" no-gutters style="width: 100%; max-width: 100%;">
          <v-col cols="12" class="pa-0 justify-start d-flex">
            {{ $t(`label.topWinners`) }}
          </v-col>
        </v-row>
        <v-row no-gutters style="overflow-x: auto; display: flex; flex-wrap: nowrap;">
          <v-col cols="12" class="pa-0 justify-start d-flex scroll-row">
            <v-btn :class="selectedButton === 'rng' ? 'selectedTab' : 'normalTab'" class="ma-2" large @click="selectButton('rng')">
              {{ $t(`label.rng_home`) }}
            </v-btn>
            <v-btn :class="selectedButton === 'ld' ? 'selectedTab' : 'normalTab'" class="ma-2" large @click="selectButton('ld')">
              {{ $t(`label.ld_home`) }}
            </v-btn>
            <v-btn :class="selectedButton === 'crash' ? 'selectedTab' : 'normalTab'" class="ma-2" large @click="selectButton('crash')">
              {{ $t(`label.crash_home`) }}
            </v-btn>
            <!--            <v-btn :class="selectedButton === 'sb' ? 'selectedTab' : 'normalTab'" class="ma-2" large @click="selectButton('sb')">-->
            <!--              {{ $t(`label.sb_home`) }}-->
            <!--            </v-btn>-->
            <v-btn :class="selectedButton === 'table' ? 'selectedTab' : 'normalTab'" class="ma-2 " large @click="selectButton('table')">
              {{ $t(`label.table_home`) }}
            </v-btn>
            <!--            <v-btn :class="selectedButton === 'fishing' ? 'selectedTab' : 'normalTab'" class="ma-2" large @click="selectButton('fishing')">-->
            <!--              {{ $t(`label.fishing_home`) }}-->
            <!--            </v-btn>-->
            <!--            <v-btn :class="selectedButton === 'cricket' ? 'selectedTab' : 'normalTab'" class="ma-2" large @click="selectButton('cricket')">-->
            <!--              {{ $t(`label.cricket_home`) }}-->
            <!--            </v-btn>-->
          </v-col>
        </v-row>
        <v-row no-gutters>
          <div
            style="overflow-x: auto; overflow-y: hidden; display: flex; flex-wrap: nowrap; width: 100%;"
            ref="scrollContainer"
            @mousedown="toggleAutoScrollFalse"
            @mouseup="toggleAutoScrollTrue"
            @scroll="handleScroll"
            @touchstart="toggleAutoScrollFalse"
            @touchend="toggleAutoScrollTrue"
          >
            <v-row justify="start" align="center" class="scroll-row pt-2 pb-2" no-gutters ref="autoScrollRow">
              <v-col v-for="(record, index) in filteredWinningRecord" :key="index" class="winningRecordColumn">
                <v-card class="pa-2 highPayoutColumn" @click="directLaunchSpecificGame(record)">
                  <v-card-title class="d-flex flex-column align-start justify-end text-white pa-0">
                    <v-img :src="record.img_cdn == null ? `${mediaUrl}/game_icons/en/${record.pv.toLowerCase()}/${record.gc}_0.jpg` : `${record.img_cdn}`" class="highPayout_game_icon"></v-img>
                    <!-- Game Name (gn) -->
                    <v-row no-gutters :class="$vuetify.breakpoint.mdAndUp ? 'pt-4 pb-4' : 'pt-2 pb-2'" class="highPayoutTextBig font-weight-bold ">{{ truncatedGameName(record.gn) }}</v-row>
                    <!-- Player Name (mc) -->
                    <v-row no-gutters class="highPayoutTextSmall">{{ record.mc }}</v-row>
                    <!-- Date/Time (pt) -->
                    <v-row no-gutters class="highPayoutTextSmall" style="color: #FF8302;">{{ record.pt }}</v-row>
                    <!-- Amount (pa) -->
                    <v-row no-gutters class="highPayoutTextBig d-flex justify-center align-center">
                      <img src="/static/image/icon/cashIcon.svg" width="12" height="12" />
                      {{ parseFloat(record.pa).toFixed(2) }}
                    </v-row>
                  </v-card-title>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-row>
      </div>
    </div>

    <app-home-highlight></app-home-highlight>
    <!--    <app-video></app-video>-->

    <!-- <img :src="wof.event_setting.home_gif_url" alt="wof" width="72" height="70" class="wofClass" @click="navigateWOFPage()"/>
    <img :src="'/static/image/home/downloadAPK_float.gif'" width="72" height="72" v-if="platform=='desktop'" class="downloadClientClass" @click="downloadAPK()"/> -->

    <!--    <img :src="grabCoin.home_gif" alt="GrabCoin" class="wofClass" @click="navigateToCoinPage()"-->
    <!--         v-if="grabCoin.status == 1 && grabCoin.home_gif != ''" />-->

    <!--    <img :src="'/static/image/home/downloadAPK_float.gif'" width="72" height="72" v-if="platform=='desktop'"
             class="downloadClientClass" @click="downloadAPK()"/> -->
  </div>
</template>

<script>
import { DevicePlatform } from '@/constants/enums'
import { ROUTE_NAME } from '@/constants/route.constants'
import AppHomeBanner from '@/components/home/HomeBanner.vue'
import RecentWinner from '@/components/home/RecentWinner'
import AppReferralHomeBanner from '@/components/home/ReferralHomeBanner'
import RecentWithdrawal from '@/components/home/RecentWithdrawal'
import RecentDeposit from '@/components/home/RecentDeposit'
import AppPlayWithUs from '@/components/home/PlayWithUs.vue'
import { AnnouncementType } from '@/constants/enums'
import { uiHelper, locale } from '@/util'
import { ANNOUNCEMENT_LIST } from '@/store/announcement.module'
import { SHARED, SESSION } from '@/constants/constants'
// import AppSportCasinoHolder from '@/components/home/SportCasinoHolder.vue'
// import NavSlot from '@/assets/svg/rng_icon.svg'
// import NavCasino from '@/assets/svg/ld_icon.svg'
// import NavAll from '@/assets/svg/all_icon.svg'
// import NavSports from '@/assets/svg/sportsbook_icon.svg'
import { Hooper, Slide, Pagination as HooperPagination } from 'hooper'
import { MEMBER_DETAIL } from '@/store/member.module'
import AppHomeHighlight from '@/components/home/Highlight.vue'
import AppVideo from '@/components/video.vue'
import AppGameTabHolder from '@/components/home/GameTabHolder.vue'
import AppReferral from '@/components/member/referral'
import { WHEEL_MODULE } from '@/store/wheel.module'
import { GRAB_COIN_SETTING } from '@/store/bonus.module'
import { REFERRAL_GET_OVERVIEW } from '@/store/referral.module'
import { HOMEPAGE_WINNING_RECORD } from '@/store/game.module'
import { SEMI_TRANSFER } from '@/store/transfer.module'

export default {
  name: 'Home',
  // metaInfo: {
  //   title: `${locale.getMessage('meta.default_title')}`,
  //   titleTemplate: `%s`,
  //   meta: [{charset: 'utf-8'}, {
  //     name: 'description',
  //     content: `${locale.getMessage('meta.home_description')}`
  //   }, {name: 'keyword', content: `${locale.getMessage('meta.home_keyword')}`}],
  //   link: [
  //     {rel: 'canonical', href: `https://www.krikya11.com/home`}
  //   ]
  // },
  components: {
    Hooper,
    Slide,
    HooperPagination,
    RecentWinner,
    AppHomeBanner,
    AppPlayWithUs,
    RecentDeposit,
    RecentWithdrawal,
    // AppSportCasinoHolder,
    // NavSlot,
    // NavCasino,
    // NavAll,
    // NavSports,
    AppVideo,
    AppHomeHighlight,
    AppGameTabHolder,
    AppReferral,
    AppReferralHomeBanner
  },
  data: () => ({
    scrollPosition: 0, // Current scroll position
    scrollSpeed: 1, // Scroll speed in pixels per frame
    isUserScrolling: false, // Flag to track if the user is scrolling
    isAutoScrolling: false, // Flag to track if auto-scroll is active
    maxScroll: 0, // Maximum scroll position (right end)
    mediaUrl: SHARED.MEDIA_SERVER_URL,
    selectedButton: 'rng',
    GainCoins: [
      { id: 1, name: 'Deposit & Free Coins', shortName: 'deposit', btn: 'Deposit', route: 'funds' },
      { id: 2, name: 'Daily Check In', shortName: 'daily', btn: 'Check-In', route: 'rewards' },
      { id: 3, name: 'Grab Coin', shortName: 'grabCoins', btn: 'Grab Coins', route: 'grab-coin' }
    ],
    SpentCoins: [
      { id: 1, name: 'Reward Store', shortName: 'rewardStore', btn: 'Redeem', route: 'rewardStore' },
      { id: 2, name: 'Krikya Wheel', shortName: 'spin', btn: 'Spin Now', route: 'wheel-of-fortune' }
    ],
    showCoin: true,
    selectionType: 'all',
    storageAnnouncement: null,
    currentLanguage: uiHelper.getLanguage(),
    filteredAnnouncement: [],
    isAndroid: uiHelper.isAndroid(),
    platform: uiHelper.getPlatform()
  }),
  computed: {
    filteredWinningRecord() {
      let records = this.$store.state.game.homePageWinningRecord.data || []

      // Filter records based on the selected button and condition for `gt`
      switch (this.selectedButton) {
        case 'rng':
          return records.filter(record => record.gt === 1) // Filter by gt = 1
        case 'ld':
          return records.filter(record => record.gt === 3) // Filter by gt = 2
        case 'sb':
          return records.filter(record => record.gt === 4 || record.gt === 10) // Filter by gt = 3
        case 'fishing':
          return records.filter(record => record.gt === 2) // Filter by gt = 4
        case 'crash':
          return records.filter(record => record.gt === 11) // Filter by gt = 5
        case 'cricket':
          return records.filter(record => record.gt === 10) // Filter by gt = 6
        case 'table':
          return records.filter(record => record.gt === 9) // Filter by gt = 7
        default:
          return records // You can return a default case if no conditions are met
      }
    },
    winningRecord() {
      return this.$store.state.game.homePageWinningRecord.data || {}
    },
    grabCoin() {
      let d = this.$store.state.bonus.grabCoinSettings
      return d
    },
    wof() {
      return this.$store.state.wheel.wheel
    },
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    announcementList() {
      return this.$store.state.announcement.announcements
    },
    memberInfo() {
      return this.$store.state.member.info
    },
    memberWallet() {
      return this.$store.state.member.walletBalance
    }
  },
  watch: {
    winningRecord() {
      if (this.$store.state.game.homePageWinningRecord === null) {
        this.getHomePageWinningRecord()
      }
      return this.$store.state.game.homePageWinningRecord.data || {}
    },
    announcementList() {
      this.storageAnnouncement = this.$store.state.announcement.announcements
      this.populateAnnouncement(this.storageAnnouncement)
    }
  },
  mounted() {
    const ae_parms_kv = {
      event_type: 'home_page', // Event type
      country_code: 'BD', // Country code
      lang_code: uiHelper.getLanguage(), // Language code
      depth: 0
    }
    window.ae_parms_kv = ae_parms_kv
    const el_adv_id = '71880509ee082f8f44596eedf687aac0'
    const scr = document.createElement('script')
    const host = '//d313lzv9559yp9.cloudfront.net'
    scr.type = 'text/javascript'
    scr.async = true
    scr.src = `${host}/${el_adv_id}.js`
    const s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(scr, s)
    this.startAutoScroll()
  },
  created() {
    this.checkShouldHideCoin()
    this.getGrabCoinSetting()
    this.getWOF()
    this.checkIncomingAction()
    this.getAnnouncement()
    this.getMemberDetail()
    this.metaTag()
    this.getHomePageWinningRecord()
  },
  beforeRouteLeave(to, from, next) {
    uiHelper.setMetaTag('og:title', `${locale.getMessage('meta.home_og_title')}`)
    uiHelper.setMetaTag('og:description', `${locale.getMessage('meta.home_og_description')}`)
    next()
  },
  methods: {
    toggleAutoScroll() {
      if (this.isAutoScrolling) {
        // Stop auto-scrolling
        this.isAutoScrolling = false
      } else {
        // Start auto-scrolling from the current position
        this.isUserScrolling = false // Make sure manual scrolling doesn't interfere
        this.isAutoScrolling = true // Start the auto-scrolling
        this.scrollAnimation()
      }
    },
    toggleAutoScrollTrue() {
      // Start auto-scrolling from the current position
      this.isUserScrolling = false // Make sure manual scrolling doesn't interfere
      this.isAutoScrolling = true // Start the auto-scrolling
      this.scrollAnimation()
    },
    toggleAutoScrollFalse() {
      this.isAutoScrolling = false
    },
    handleScroll() {
      const scrollContainer = this.$refs.scrollContainer
      // If the user manually scrolls, mark it as manual scroll
      if (!this.isAutoScrolling) {
        this.isUserScrolling = true
      }
      this.scrollPosition = scrollContainer.scrollLeft
      // Check if the user manually scrolled to the end
      if (scrollContainer.scrollLeft + scrollContainer.clientWidth >= scrollContainer.scrollWidth) {
        this.resetScroll() // Reset the scroll position if the user scrolls to the end
      }
    },
    startAutoScroll() {
      // Initialize auto-scroll
      const scrollContainer = this.$refs.scrollContainer
      this.maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth
      this.scrollPosition = scrollContainer.scrollLeft || 0 // Start from the current position
      this.isUserScrolling = false // Ensure that manual scrolling doesn't interfere
      this.isAutoScrolling = true // Mark that we are auto-scrolling

      // Start the animation loop
      this.scrollAnimation()
    },
    scrollAnimation() {
      // Prevent animation if it's stopped
      if (!this.isAutoScrolling) return
      const scrollContainer = this.$refs.scrollContainer
      // Move the scroll position by scrollSpeed each frame
      this.scrollPosition += this.scrollSpeed
      // Apply the new scroll position
      scrollContainer.scrollLeft = this.scrollPosition
      // If we've reached the end of the scroll, reset and start again
      if (this.scrollPosition >= this.maxScroll) {
        this.resetScroll()
        return
      }
      // Continue the animation
      requestAnimationFrame(this.scrollAnimation)
    },
    resetScroll() {
      // Reset the scroll position when the animation completes or user reaches the end
      const scrollContainer = this.$refs.scrollContainer

      // Stop auto-scrolling if it's active
      this.isAutoScrolling = false

      // If the user was scrolling manually, prevent reset during manual scroll
      if (this.isUserScrolling) {
        this.isUserScrolling = false
        return
      }
      // Reset scroll to the beginning
      scrollContainer.scrollLeft = 0
      // Restart auto-scroll after a small delay
      setTimeout(() => {
        this.startAutoScroll()
      }, 20) // Delay before restarting the animation
    },
    selectButton(button) {
      this.selectedButton = button
      this.resetScroll()
    },
    semiTransfer(gameInfo) {
      let obj = {
        to_wallet: gameInfo.provider
      }
      return this.$store.dispatch(`${SEMI_TRANSFER}`, { obj })
    },
    directLaunchSpecificGame(record, isDemo) {
      this.toggleAutoScrollFalse()
      if (!this.isLoggedIn) {
        this.openLoginDialog()
      } else {
        let game_type = 'rng'
        switch (record.gt) {
          case 1:
            game_type = 'rng'
            break
          // Add other cases as needed
          case 2:
            game_type = 'fishing' // For example, another game type
            break
          case 3:
            game_type = 'ld' // For example, another game type
            break
          case 4:
            game_type = 'sb' // For example, another game type
            break
          case 9:
            game_type = 'table' // For example, another game type
            break
          case 10:
            game_type = 'cricket' // For example, another game type
            break
          case 11:
            game_type = 'crash' // For example, another game type
            break
          default:
            game_type = 'rng' // Default to 'rng' if no match
            break
        }
        const game = {
          game_code: record.gc,
          game_id: 0,
          game_type: game_type,
          provider: record.pv.toLowerCase()
        }
        let routeData = this.$router.resolve({
          name: ROUTE_NAME.LAUNCH_GAME_LOBBY,
          params: {
            provider: record.pv.toLowerCase(),
            type: game_type,
            lang: this.$route.params.lang
          },
          query: {
            id: 0,
            code: record.gc,
            demo: isDemo ? 1 : 0
          }
        })
        try {
          this.$ga.event('Game', `${isDemo ? 'Demo' : 'Real'} Play`, `${game.provider} - Slot - ${record.gn}`, 0)
        } catch (err) {
          console.log(err)
        }
        if (record.gt == 4 || record.gt == 10) {
          // await uiHelper.openPopup(routeData.href, 'Game Play Lobby', 1440, 810)
          window.open(routeData.href)
          this.semiTransfer(game)
        } else {
          window.open(routeData.href)
          this.semiTransfer(game).then(() => {})
        }
        // window.open(routeData.href, '_blank')
        // this.semiTransfer(game).then(() => {})
      }
    },
    truncatedGameName(gameName) {
      const words = gameName
        .split(' ')
        .slice(0, 3)
        .join(' ')
      if (gameName.split(' ').length > 2) {
        return words + '...'
      } else {
        return words
      }
    },
    getHomePageWinningRecord() {
      let data = {
        currency: uiHelper.getCurrency(),
        size: 100
      }
      this.$store.dispatch(`${HOMEPAGE_WINNING_RECORD}`, { data })
    },
    handleButtonClick() {
      // Your button click logic here
    },
    downloadAPK() {
      uiHelper.downloadAPK()
    },
    metaTag() {
      const currentUrl = window.location.href
      uiHelper.setCanonical(currentUrl)
      uiHelper.setMetaTag('url', currentUrl)
      uiHelper.setMetaTag('og:url', currentUrl)
      uiHelper.setMetaTag('og:type', 'website')
      uiHelper.setMetaTag('og:site_name', 'Krikya')
      uiHelper.setMetaTag('og:image', `${currentUrl}/static/image/home/logo.webp`)
      uiHelper.setMetaTag('og:title', `${locale.getMessage('meta.home_og_title')}`)
      uiHelper.setMetaTag('og:description', `${locale.getMessage('meta.home_og_description')}`)
      uiHelper.setMetaTag('description', `${locale.getMessage('meta.home_description')}`)
      uiHelper.setMetaTag('keywords', `${locale.getMessage('meta.home_keyword')}`)
      // uiHelper.setCanonical("https://www.krikya11.com/home/");
      uiHelper.setTitle(`${locale.getMessage('meta.home_title')}`)

      const domain_all = window.location.hostname.toLowerCase()

      // Update the og:title content based on the domain
      if (domain_all.includes('krikya.club')) {
        uiHelper.setTitle(`${locale.getMessage('meta.krikya_club_title')}`)
        uiHelper.setMetaTag('description', `${locale.getMessage('meta.krikya_club_description')}`)
      } else {
        if (this.$route.params.lang) {
          uiHelper.setTitle(`${locale.getMessage('meta.home_lang_title')}`)
          uiHelper.setMetaTag('description', `${locale.getMessage('meta.home_lang_description')}`)
        } else {
          uiHelper.setTitle(`${locale.getMessage('meta.home_title')}`)
          uiHelper.setMetaTag('description', `${locale.getMessage('meta.home_description')}`)
        }
      }
      const domainWithProtocol = currentUrl.split('/')[2]
      const domain = domainWithProtocol.replace(/(^\w+:|^)\/\//, '')
      const Links = `https://${domain}`
      const Linksen = `https://${domain}/en-BD`
      const Linksbn = `https://${domain}/bn-BD`
      uiHelper.setCanonical(currentUrl)
      uiHelper.setHreflangLinks(Links)
      uiHelper.setHreflangLinksen(Linksen)
      uiHelper.setHreflangLinksbd(Linksbn)
    },
    getGrabCoinSetting() {
      let filter = {
        currency: uiHelper.getCurrency()
      }
      this.$store.dispatch(`${GRAB_COIN_SETTING}`, { filter })
    },
    checkShouldHideCoin() {
      if (typeof uiHelper.getCookie(SESSION.HIDE_COIN) != 'undefined' && uiHelper.getCookie(SESSION.HIDE_COIN) == 1) {
        this.showCoin = false
      } else {
        this.showCoin = true
      }
    },
    dontShowMeAgain() {
      this.showCoin = false
      uiHelper.setCookie(SESSION.HIDE_COIN, 1, 0.5)
    },
    navigateToCoinPage() {
      this.$router.push({
        name: ROUTE_NAME.GRAB_COIN,
        params: {
          type: 'coin',
          lang: this.$route.params.lang
        }
      })
    },
    navigateToCardManiaPage() {
      this.$router.push({
        name: ROUTE_NAME.CARD_MANIA,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    navigateWOFPage() {
      if (uiHelper.getPlatform() == DevicePlatform.DESKTOP) {
        this.$router.push({
          name: ROUTE_NAME.WOF,
          lang: this.$route.params.lang
        })
      } else {
        this.$router.push({
          name: ROUTE_NAME.MWOF,
          lang: this.$route.params.lang
        })
      }
    },
    getWOF() {
      let currency = uiHelper.getCurrency()
      let filter = {
        currency: currency
      }
      this.$store.dispatch(`${WHEEL_MODULE}`, { filter })
    },
    getMemberDetail() {
      if (this.isLoggedIn) this.$store.dispatch(`${MEMBER_DETAIL}`)
    },
    goToAffilateProfilePage() {
      this.$router.push({
        name: ROUTE_NAME.AFFILIATE_LINK,
        lang: this.$route.params.lang
      })
    },
    goToAffilateHomePage() {
      this.$router.push({
        name: ROUTE_NAME.AFFILIATE_HOME,
        lang: this.$route.params.lang
      })
    },
    goToDepositPage() {
      if (uiHelper.getPlatform() == DevicePlatform.MOBILE) {
        let routeData = this.$router.resolve({
          name: ROUTE_NAME.DEPOSIT,
          params: {
            lang: this.$route.params
          }
        })
        window.open(routeData.href)
      } else {
        this.$router.push({
          name: ROUTE_NAME.DEPOSIT,
          params: {
            lang: this.$route.params
          }
        })
      }
    },
    getAnnouncement() {
      if (this.storageAnnouncement == null) {
        let obj = {
          site: uiHelper.getPlatform(),
          type: AnnouncementType.ALL,
          page: '',
          itemsPerPage: ''
        }
        this.$store.dispatch(`${ANNOUNCEMENT_LIST}`, { obj })
      } else {
        this.populateAnnouncement(this.storageAnnouncement)
      }
    },
    populateAnnouncement(announcementData) {
      let p = []
      announcementData.forEach(announcement => {
        p.push({
          id: announcement.id,
          date: announcement.announcementDate,
          title:
            announcement.titleLocale.find(x => x.language == this.currentLanguage) != null
              ? announcement.titleLocale.find(x => x.language == this.currentLanguage).title
              : announcement.titleLocale.find(x => x.language == 'en') != null
              ? announcement.titleLocale.find(x => x.language == 'en').title
              : announcement.titleLocale[0].title,
          message:
            announcement.messageLocale.find(x => x.language == this.currentLanguage) != null
              ? announcement.messageLocale.find(x => x.language == this.currentLanguage).message
              : announcement.messageLocale.find(x => x.language == 'en') != null
              ? announcement.messageLocale.find(x => x.language == 'en').message
              : announcement.messageLocale[0].message
        })
      })
      this.filteredAnnouncement = p
    },
    checkIncomingAction() {
      let action = this.$route.params.action

      if (action == SHARED.RESET_PASSWORD) {
        let memberCode = this.$route.params.memberCode
        let contact = this.$route.params.contact
        if (memberCode != null && memberCode != undefined && contact != null && contact != undefined) this.$parent.openResetPasswordDialog(memberCode, contact)
      } else if (action == SHARED.INFO_VERIFICATION) {
        let memberCode = this.$route.params.memberCode
        let otp = this.$route.params.otp
        let type = this.$route.params.type
        let contact = this.$route.params.contact
        if (memberCode != null && memberCode != undefined && otp != null && otp != undefined && type != null && type != undefined)
          this.$parent.memberContactVerification(memberCode, otp, type, contact)
      } else if (action == SHARED.REGISTER) {
        this.openRegisterDialog()
      }
    },
    openRegisterDialog() {
      this.$parent.openRegisterDialog()
    },
    openLoginDialog() {
      this.$parent.openLoginDialog()
    }
  }
}
</script>
<style lang="scss">
.highPayout_game_icon {
  width: 100%;
  height: 85px;
  border-radius: 5px;
  object-fit: contain;
}
.highPayoutTextBig {
  font-size: 11px !important;
  height: 40px;
  line-height: 1rem;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.highPayoutTextSmall {
  font-size: 10px !important;
  line-height: 1rem;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
}
.winningRecordColumn {
  width: 140px;
  max-width: 140px;
  padding-right: 10px !important;
  height: 210px !important;
}
.highPayoutColumn {
  position: relative;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 5px;
}
.scroll-row {
  display: flex;
  flex-wrap: nowrap; /* Prevent the columns from wrapping to the next line */
}

.auto-scroll-row {
  display: flex;
  width: max-content;
  animation: auto-scroll 35s linear infinite; /* Adjust duration for speed */
  -webkit-overflow-scrolling: touch;
  will-change: transform;
}

@keyframes auto-scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%); /* Moves content to the left */
  }
}
.selectedTab {
  background: transparent linear-gradient(180deg, #fdd20d 0%, #ff7d01 100%) 0% 0% no-repeat padding-box;
  border-radius: 16px;
  height: 25px !important;
  width: 50px !important;
  font-size: 12px !important;
  color: white !important;
}
.normalTab {
  background: transparent !important;
  border-radius: 16px;
  height: 25px !important;
  width: 50px !important;
  font-size: 12px !important;
}
.item-button-container {
  min-width: 114px;
  padding: 4px 12px;
  a {
    text-decoration: none;
  }
}
.upper-coinTips {
  text-align: center;
  text-transform: uppercase;
  color: #001958;
  font-size: 14px;
  font-weight: bold;
}

.lower-coinTips {
  text-align: center;
  color: #000000;
  font-size: 11px;
  font-weight: 600;
}
.coins-Tips-card {
  background-color: #fff;
  padding: 0;
  border-radius: 4px;
  .coins-Tips-card-title {
    background-color: var(--v-primary-base);
    border-radius: 4px 4px 0 0;
  }
  .dialog-close-icon {
    color: #fff !important;
  }
}
.custom-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  border: 2px solid #14805e;
  border-radius: 5px;
  padding: 10px 0px; /* Add padding as needed */
  margin: 10px !important;
  height: 120px;

  @media (max-width: 424px) {
    margin: 10px 2px !important;
  }
}

.item-image-pop-up {
  width: 50px; /* Adjust the width as needed */
  height: 50px;
}

.item-name {
  width: 100%;
  font-weight: bold;
  font-size: 9px;
  white-space: nowrap;

  @media (max-width: 450px) {
    font-size: 8px;
  }
}

.item-button {
  font-size: 10px !important;
  width: 100%;
  text-transform: none !important;
  background-color: #f56908 !important;
  color: #fff !important;
  height: 27px !important;
}
.item-button-close {
  background-color: var(--v-primary-base) !important;
  border-radius: 5px;
  color: #fff !important;
  width: 90% !important;
  margin-bottom: 10px;
}
.active_click {
  background-color: white;
}

.icon_gameHome {
  fill: white;
  color: black;
  stroke: #9c9ff3;
  width: 40px;
  height: 33px;
  padding-top: 4px;
}

.hooper-pagination {
  position: absolute;
  bottom: -6%;
  right: 52%;
  transform: translateX(52%);
  display: flex;
  padding: 5px 10px;

  ol.hooper-indicator {
    padding-left: 0;
  }
}

.hooper-indicator {
  width: 15px;
  height: 15px;
  border-radius: 10px;
}

.partner-box {
  height: 450px;
  position: relative;

  .partner-row {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 100%;

    .partner-col {
      position: relative;

      .partner-title {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .partner-desc {
        border-bottom: 4px solid var(--v-primary-base);
      }

      .partner-box-trophy {
        position: absolute;
        bottom: 0;
        right: 600px;
      }

      .partner-box-footballer {
        position: absolute;
        bottom: 0px;
        height: 420px;
        right: 100px;
        width: 800px;
      }
    }
  }
}

.joinInTheFun {
  border-bottom: 2px solid;
  border-color: var(--v-secondary-base);
  border-radius: 0px !important;
  cursor: pointer;
  color: var(--v-secondary-base);
  font-size: 16px;

  &:hover {
    border-color: var(--v-primary-base);
    color: var(--v-primary-base);
  }
}

.announcement-marquee-box {
  max-width: 1840px;
}

.home-announcment-content {
  p {
    margin-bottom: 0 !important;
  }
}

@media (max-width: 1650px) {
  .partner-box {
    .partner-row {
      .partner-col {
        .partner-box-trophy {
          right: 550px;
        }

        .partner-box-footballer {
          height: 380px;
          right: 80px;
        }
      }
    }
  }
}

@media (max-width: 1500px) {
  .partner-box {
    .partner-row {
      .partner-col {
        .partner-box-trophy {
          right: 360px;
          width: 280px;
        }

        .partner-box-footballer {
          height: auto;
          right: 50px;
          width: 600px;
        }
      }
    }
  }

  .joinInTheFun,
  .home-announcment-title,
  .home-announcment-content p {
    font-size: 15px;
  }
}

@media (max-width: 1350px) {
  .partner-box {
    height: 340px;

    .partner-row {
      .partner-col {
        .partner-title {
          width: 300px;
        }

        .partner-box-footballer {
          width: 500px;
        }

        .partner-box-trophy {
          right: 275px;
          width: 220px;
        }
      }
    }
  }
}

@media (max-width: 1263px) {
  .partner-box .partner-row .partner-col .partner-desc {
    font-size: 26px;
  }
  .joinInTheFun,
  .home-announcment-title,
  .home-announcment-content p {
    font-size: 14px;
  }
}

@media (max-width: 1024px) {
  .partner-box .partner-row .partner-col .partner-desc {
    font-size: 24px;
  }
}

@media (max-width: 959px) {
  .wofClass {
    width: 72px !important;
    height: 75px !important;
  }

  .cmClass {
    width: 72px !important;
    height: 75px !important;
  }

  .partner-box {
    height: 600px;
  }

  .partner-box .partner-row .partner-col.partner-box-message {
    height: 300px;
  }
  .partner-box .partner-row .partner-col.partner-box-image {
    height: 300px;
  }
}
@media (min-width: 599px) {
  .highPayout_game_icon {
    width: 100%;
    height: 110px;
    border-radius: 5px;
    object-fit: contain;
  }
  .highPayoutTextBig {
    height: 40px;
    align-items: center;
    font-size: 14px !important;
    line-height: 1rem;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    padding-bottom: 4px;
  }
  .highPayoutTextSmall {
    font-size: 12px !important;
    line-height: 1rem;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    padding-bottom: 4px;
  }
  .winningRecordColumn {
    width: 180px;
    max-width: 180px;
    padding-right: 10px !important;
    height: 250px !important;
  }
}
@media (min-width: 959px) {
  .highPayout_game_icon {
    height: 130px;
  }
  .highPayoutTextBig {
    height: 55px;
  }
  .winningRecordColumn {
    height: 300px !important;
  }
}
@media (max-width: 599px) {
  .hooper-pagination {
    bottom: -3%;
  }

  .bg_home {
    .bg_filter {
      padding: 3% 3%;
    }
  }
  .partner-box {
    height: 300px;
  }
  .partner-box .partner-row .partner-col.partner-box-image {
    display: none;
  }
  .joinInTheFun,
  .home-announcment-title,
  .home-announcment-content p {
    font-size: 13px;
  }
}

@media (max-width: 425px) {
  .hooper-pagination {
    bottom: -5%;
  }
  // .v-badge__badge {
  //   bottom: 8px !important;
  // }
  .partner-box .partner-row .partner-col .partner-title {
    width: 220px;
  }
}

.wofClass {
  bottom: 23%;
  right: 0.5%;
  //z-index: 9999999;
  cursor: pointer;
  position: fixed;
  width: 100px;
}

.coinTipsClass {
  bottom: 16%;
  right: -3px;
  z-index: 99;
  cursor: pointer;
  position: fixed;
  width: 87px;
}

.downloadClientClass {
  bottom: 30%;
  right: 0.5%;
  //z-index: 9999999;
  cursor: pointer;
  position: fixed;
}
</style>
